import { render, staticRenderFns } from "./WhatsappLimit.vue?vue&type=template&id=89e296e4&"
import script from "./WhatsappLimit.vue?vue&type=script&lang=js&"
export * from "./WhatsappLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports